import apiClient from "./client";

export const getDownloads = async ({ language = "en" } = {}) => {
  const response = await apiClient.get("/downloads", {
    params: { language },
  });
  return response.data;
};
